import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { CircularProgress, Typography } from '@emburse/ui-core';
const LoadingState = ({ caption }) => {
    return (_jsxs("div", Object.assign({ style: { textAlign: 'center' } }, { children: [_jsx(CircularProgress, { color: "primary", variant: "indeterminate" }), caption && _jsx(Typography, Object.assign({ variant: "h6" }, { children: caption }))] })));
};
export { LoadingState };
